import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import { Fehlergrenze } from './components/Fehlergrenze'
import { LoginGate } from './components/LoginGate'
import '@fontsource-variable/source-sans-3'
import './styles/global.css'

const container = document.getElementById('root')
if (!container) throw new Error('Root element #root not found')

createRoot(container).render(
  <StrictMode>
    {/* Außen noch eine: Stürzt die Hülle selbst ab, bleibt statt Schwarz die Meldung. */}
    <Fehlergrenze ganzeSeite>
      <LoginGate>
        <App />
      </LoginGate>
    </Fehlergrenze>
  </StrictMode>,
)
